module.exports = __webpack_public_path__ + "img/68.79c51212.jpg";